export const ID = 'a0ec0310-f286-4968-8a7f-5ca9227d59e9';

export const NAME = 'PopUp';
